import { RootSvg, RootSvgProps } from './RootSvg';

export function StorybookIcon(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m20.69 2.415-.002-.067a1.079 1.079 0 0 0-1.148-1.002l-1.192.073.09 2.46a.16.16 0 0 1-.156.165.163.163 0 0 1-.106-.034l-.8-.624-.948.711a.163.163 0 0 1-.227-.03l-.015-.024a.16.16 0 0 1-.017-.08l.103-2.415-11.85.733a1.076 1.076 0 0 0-1.015 1.11l.667 17.592c.021.557.47 1.005 1.033 1.03l14.451.642.049.001c.598 0 1.083-.48 1.083-1.071V2.415Zm-7.177 6.962c0 .417 2.838.217 3.219-.076 0-2.839-1.54-4.33-4.358-4.33-2.818 0-4.397 1.514-4.397 3.787 0 2.276 1.785 3.269 3.302 4.112 1.12.622 2.095 1.163 2.095 2.08 0 .606-.3.966-.96.966-.86 0-1.2-.434-1.16-1.911 0-.32-3.277-.42-3.377 0-.255 3.58 1.999 4.612 4.577 4.612 2.499 0 4.457-1.318 4.457-3.704 0-2.49-1.886-3.48-3.444-4.297-1.098-.575-2.032-1.066-2.032-1.934 0-.852.64-.966 1.02-.966.399 0 1.118.07 1.059 1.66Z"
        fill="#FF4785"
      />
    </RootSvg>
  );
}
